module.exports = __webpack_public_path__ + "img/04.c35f3b83.jpg";